import { createModel } from '@/store/tools';

const url = '/?cmd=com.xqxc.api.pig.mis.biz.platform.AreaInfoMisService.findAreaByParentId';

const model = {
    namespace: 'operationCommon',
    build: (T, A, S, R) => ({
        actiontypes: {
            'getProvinces': T('getProvinces'),
            'getCitys': T('getCitys'),
            'getAreas': T('getAreas'),
            'getStatus': T('getStatus'),
            'getAreaTree': T('getAreaTree'),
            'getRegions': T('getRegions'),
            'getCityCounty': T('getCityCounty'),
            'getEnterpriseCityCounty': T('getEnterpriseCityCounty'),
        },
        actions: {
            'getProvinces': A('getProvinces'),
            'getCitys': A('getCitys'),
            'getAreas': A('getAreas'),
            'getStatus': A('getStatus'),
            'getAreaTree': A('getAreaTree'),
            'getRegions': A('getRegions'),
            'getCityCounty': A('getCityCounty'),
            'getEnterpriseCityCounty': A('getEnterpriseCityCounty'),
        },
        sagas: {
            'getProvinces': S('getProvinces', url),
            'getCitys': S('getCitys', url),
            'getAreas': S('getAreas', url),
            'getStatus': S('getStatus', '/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum'),
            'getAreaTree': S('getAreaTree', '/?cmd=com.xqxc.api.pig.mis.biz.platform.AreaInfoMisService.findTreeAreaInfo'),
            'getRegions': S('getRegions', '/?cmd=com.xqxc.api.pig.mis.biz.platform.AreaInfoMisService.listProvince'),
            'getCityCounty': S('getCityCounty', '/?cmd=com.xqxc.api.pig.mis.biz.rules.RiderDeliveryFeeRuleMisService.findAreaByParentId'),
            'getEnterpriseCityCounty': S('getEnterpriseCityCounty', '/?cmd=com.xqxc.api.pig.mis.biz.rules.RiderDeliveryFeeRuleMisService.findEnterpriseAreaByParentId'),
        },
        reducers: {
            'provinces': R('getProvinces', []),
            'citys': R('getCitys', []),
            'areas': R('getAreas', []),
            'status': R('getStatus', []),
            'areaTree': R('getAreaTree', []),
            'regions': R('getRegions', {}),
            'cityCounty': R('getCityCounty', []),
            'enterpriseCityCounty': R('getEnterpriseCityCounty', []),
        }
    })
};
export default createModel(model);